import { ParallelSplitConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getParallelSplitTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];

	const config = microTaskConfigType as ParallelSplitConfig;

	return [
		{
			id: 'add-split',
			selector: '[data-tour="add-split"]',
			content: 'Adds a new destination service/split to the task.',
		},
		...(config.parallelSplitMappings.length > 0
			? [
					{
						id: 'destination-service',
						selector: '[data-tour="destination-service"]',
						content:
							'Required: This is a collection of destination services that the payload will be replicated to.',
					},
					{
						id: 'delete-destination-service',
						selector: '[data-tour="delete-destination-service"]',
						content: 'Removes the corresponding Destination Service from the task.',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
